// -----------------------------------------------------------------------------
// Future Roofing and Repair — central content file.
// Admin-friendly: edit text, services, FAQs, and gallery images here.
// -----------------------------------------------------------------------------

export const business = {
  name: "Future Roofing and Repair",
  owner: "Kyle McClinton",
  phone: "215-806-5038",
  phoneHref: "tel:+12158065038",
  email: "kyleroofer@gmail.com",
  emailHref: "mailto:kyleroofer@gmail.com",
  address: {
    street: "134 Otter St",
    city: "Bristol",
    state: "PA",
    zip: "19007",
    full: "134 Otter St, Bristol, PA 19007",
  },
  hours: "7:00 AM – 5:00 PM",
  serviceArea: "Bucks County & surrounding areas",
  yearsExperience: 13,
  founded: 2025,
  mapEmbed:
    "https://www.google.com/maps?q=134+Otter+St,+Bristol,+PA+19007&output=embed",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  { label: "Residential", to: "/residential" },
  { label: "Commercial", to: "/commercial" },
  { label: "Gutters & Siding", to: "/gutters" },
  { label: "Gallery", to: "/gallery" },
  { label: "FAQ", to: "/faq" },
  { label: "Contact", to: "/contact" },
];

export const trustBadges = [
  { label: "Licensed", icon: "BadgeCheck" },
  { label: "Insured", icon: "ShieldCheck" },
  { label: "GAF Certified", icon: "Award" },
  { label: "Family-Owned", icon: "Users" },
  { label: "Locally Owned", icon: "MapPin" },
  { label: "13 Years of Experience", icon: "CalendarClock" },
];

export const homeServices = [
  { title: "Roof Repair", desc: "Fast, reliable fixes for leaks, missing shingles, and worn roofing.", icon: "Wrench", to: "/residential" },
  { title: "Residential Roofing", desc: "Complete roofing for homes of every style and size.", icon: "House", to: "/residential" },
  { title: "Commercial Roofing", desc: "Flat and low-slope systems for businesses and properties.", icon: "Building2", to: "/commercial" },
  { title: "Flat Roofing", desc: "TPO, EPDM, PVC, and built-up flat roof systems.", icon: "PanelTop", to: "/commercial" },
  { title: "Metal Roofing", desc: "Durable, energy-efficient metal roofing for homes and businesses.", icon: "Layers", to: "/residential" },
  { title: "Shingle Roofing", desc: "Asphalt shingle installation and repair with quality materials.", icon: "Layers3", to: "/residential" },
  { title: "Gutters & Siding", desc: "Gutter installation & repair, siding, fascia, and roofline protection.", icon: "Droplets", to: "/gutters" },
  { title: "Siding", desc: "Siding installation and repair to protect and finish your home.", icon: "LayoutPanelLeft", to: "/gutters" },
  { title: "Fascia & Soffit", desc: "Repair and replacement of fascia and soffit boards.", icon: "Ruler", to: "/gutters" },
  { title: "Attic Ventilation", desc: "Balanced ventilation to protect your roof and lower attic heat.", icon: "Wind", to: "/residential" },
  { title: "Roof Maintenance", desc: "Inspections and upkeep to extend the life of your roof.", icon: "ClipboardCheck", to: "/residential" },
];

export const residentialServices = [
  "Roof installation",
  "Roof repair",
  "Shingle roofing",
  "Metal roofing",
  "Flat roofing",
  "Slate roofing",
  "Roof inspections",
  "Leak detection",
  "Chimney flashing repair",
  "Skylight installation & repair",
  "Gutter installation",
  "Gutter repair",
  "Siding",
  "Fascia and soffit",
  "Attic ventilation",
  "Roof maintenance",
];

export const residentialProblems = [
  "Roof leaks",
  "Aging roofs",
  "Damaged shingles",
  "Flashing issues",
  "Gutter problems",
  "Ventilation issues",
];

export const commercialServices = [
  "Commercial roof installation",
  "Commercial roof repair",
  "Flat roofing",
  "TPO roofing",
  "EPDM roofing",
  "PVC roofing",
  "Built-up roofing",
  "Metal roofing",
  "Roof coatings",
  "Commercial roof inspections",
  "Commercial roof maintenance",
  "Leak detection",
  "Apartment building roofing",
  "Office building roofing",
  "Retail building roofing",
  "Warehouse roofing",
  "Industrial roofing",
  "HOA / community roofing",
];

export const commercialClients = [
  "Property managers",
  "Landlords",
  "Builders & contractors",
  "Developers",
  "Apartment buildings",
  "Office buildings",
  "Retail buildings",
  "Warehouses",
  "Industrial buildings",
  "HOA / community properties",
];

export const gutterServices = [
  "Gutter installation",
  "Gutter repair",
  "Fascia repair & replacement",
  "Soffit repair & replacement",
  "Siding installation & repair",
  "Drainage solutions",
  "Roofline protection",
];

export const materials = [
  "Asphalt-based shingles",
  "Slate",
  "Cedar",
  "TPO",
  "PVC",
  "EPDM",
  "Metal roofing",
  "Flat roof systems",
  "Roof coatings",
];

export const brands = ["IKO", "Atlas", "GAF"];

export const discounts = [
  "Senior",
  "Military",
  "Veteran",
  "First responder",
  "Teacher",
];

export const serviceTypeOptions = [
  "Roof repair",
  "Roof inspection",
  "Gutters",
  "Commercial roofing",
  "Other",
];

export const faqs = [
  {
    q: "Do you offer free roof inspections?",
    a: "Inspections may have a fee. Estimates are available.",
  },
  {
    q: "Do you work with insurance claims?",
    a: "Yes, Future Roofing and Repair works with insurance companies, helps with paperwork, and can meet with adjusters.",
  },
  {
    q: "What roofing materials do you install?",
    a: "Shingles, slate, cedar, metal roofing, TPO, PVC, EPDM, flat roofing systems, and roof coatings.",
  },
  {
    q: "How long does a new roof last?",
    a: "It depends on the material, installation, ventilation, maintenance, and weather exposure.",
  },
  {
    q: "Do you clean up after the job?",
    a: "Yes, cleanup is part of the job process.",
  },
  {
    q: "Are you licensed and insured?",
    a: "Yes, Future Roofing and Repair is licensed and insured.",
  },
  {
    q: "Do you work on both homes and businesses?",
    a: "Yes, residential and commercial roofing services are available.",
  },
  {
    q: "Do you offer warranties?",
    a: "Workmanship warranties and manufacturer warranties may be available depending on the project.",
  },
  {
    q: "What areas do you serve?",
    a: "The main service area is Bucks County, Pennsylvania, with surrounding areas available by request.",
  },
  {
    q: "What should I do if my roof is leaking?",
    a: "Call Future Roofing and Repair immediately at 215-806-5038, especially if water is actively entering the property.",
  },
];

export const images = {
  hero: "/images/hero.jpg",
  residential: "/images/residential.jpg",
  commercial: "/images/commercial.jpg",
  gutters: "/images/gutters.jpg",
  about: "/images/about.jpg",
  metal: "/images/metal.jpg",
  storm: "/images/storm.jpg",
};

export const galleryCategories = [
  "All",
  "Residential Roofing",
  "Commercial Roofing",
  "Roof Repairs",
  "Metal Roofing",
  "Flat Roofing",
  "Before & After",
];

export const galleryItems = [
  { src: "https://images.pexels.com/photos/28999250/pexels-photo-28999250.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Residential Roofing", alt: "Residential rooftops" },
  { src: "https://images.unsplash.com/photo-1755114203680-d39d95efa82c?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Residential Roofing", alt: "Aerial view of a home with a new roof" },
  { src: "https://images.unsplash.com/photo-1710139323182-69622cad5c3b?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Residential Roofing", alt: "Row of homes with shingle roofs" },
  { src: "https://images.pexels.com/photos/18098285/pexels-photo-18098285.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Residential Roofing", alt: "Home with a slate roof" },
  { src: "https://images.unsplash.com/photo-1768677432858-b9a8608dd849?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Commercial Roofing", alt: "Commercial building rooftops" },
  { src: "https://images.pexels.com/photos/27793722/pexels-photo-27793722.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Commercial Roofing", alt: "Industrial warehouse roof" },
  { src: "https://images.unsplash.com/photo-1640476750068-72c645e653cd?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Flat Roofing", alt: "Flat commercial roof from above" },
  { src: "https://images.unsplash.com/photo-1726589004565-bedfba94d3a2?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Roof Repairs", alt: "Roofer repairing a roof" },
  { src: "https://images.pexels.com/photos/37704251/pexels-photo-37704251.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Roof Repairs", alt: "Roofer renovating a brick house roof" },
  { src: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Roof Repairs", alt: "Worker using a drill on a roof" },
  { src: "https://images.unsplash.com/photo-1602193230480-7840a38eb0c3?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Metal Roofing", alt: "Black standing seam metal roof" },
  { src: "https://images.unsplash.com/photo-1602193458517-db6caca8f1fe?crop=entropy&cs=srgb&fm=jpg&q=80&w=940", category: "Metal Roofing", alt: "Gray metal roof" },
  { src: "https://images.pexels.com/photos/26570514/pexels-photo-26570514.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Metal Roofing", alt: "Building with a metal roof" },
  { src: "https://images.pexels.com/photos/26612731/pexels-photo-26612731.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Before & After", alt: "House roof with brick chimney" },
  { src: "https://images.pexels.com/photos/37623622/pexels-photo-37623622.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", category: "Before & After", alt: "New roofing tiles being installed" },
];
